<template>
  <v-sheet class="d-inline-block">
    <v-btn color="primary" @click="showDialog = true"> {{ label }}</v-btn>

    <v-dialog v-model="showDialog" :max-width="maxWidth">
      <v-card density="compact">
        <v-card-title v-if="title" class="text-h6 font-weight-bold wrap white-space-word-break">
          {{ title }}
        </v-card-title>

        <v-card-text><slot /></v-card-text>

        <v-card-actions class="justify-end">
          <v-btn @click="showDialog = false">Отмена</v-btn>
          <v-btn color="primary" @click="confirm">Подтвердить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script setup>
import { ref } from 'vue'

const emit = defineEmits(['accept'])

defineProps({
  label: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: false,
    default: null,
  },
  maxWidth: {
    type: Number,
    required: false,
    default: 400,
  },
})

const showDialog = ref(false)

const confirm = () => {
  showDialog.value = false
  emit('accept')
}
</script>

<style scoped lang="scss">
.v-card-text {
  font-size: 1.2em !important;
}
</style>
